function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  d: "M0 0H30V30H0z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M18.9 7.828l-1.567-.2a7.875 7.875 0 0 0-.474-1.145l.967-1.246a1.239 1.239 0 0 0-.1-1.649l-1.311-1.311a1.242 1.242 0 0 0-1.654-.106l-1.244.967a7.847 7.847 0 0 0-1.146-.474l-.2-1.564A1.248 1.248 0 0 0 10.933 0H9.067a1.248 1.248 0 0 0-1.239 1.1l-.2 1.567a7.756 7.756 0 0 0-1.146.474l-1.244-.97a1.24 1.24 0 0 0-1.649.1L2.277 3.584a1.242 1.242 0 0 0-.106 1.655l.967 1.245a7.783 7.783 0 0 0-.474 1.145l-1.564.2A1.248 1.248 0 0 0 0 9.067v1.867a1.248 1.248 0 0 0 1.1 1.238l1.567.2a7.875 7.875 0 0 0 .474 1.145l-.967 1.246a1.239 1.239 0 0 0 .1 1.649l1.313 1.313a1.243 1.243 0 0 0 1.654.1l1.245-.967a7.693 7.693 0 0 0 1.145.474l.2 1.563A1.248 1.248 0 0 0 9.067 20h1.867a1.248 1.248 0 0 0 1.238-1.1l.2-1.567a7.875 7.875 0 0 0 1.145-.474l1.246.967a1.239 1.239 0 0 0 1.649-.1l1.313-1.312a1.241 1.241 0 0 0 .106-1.654l-.967-1.245a7.694 7.694 0 0 0 .474-1.145l1.563-.2A1.248 1.248 0 0 0 20 10.933V9.067a1.247 1.247 0 0 0-1.1-1.238zM10 14.167A4.167 4.167 0 1 1 14.167 10 4.171 4.171 0 0 1 10 14.167z",
  transform: "translate(5 5)"
});

function SvgIconSetting(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSetting);
export default __webpack_public_path__ + "static/media/iconSetting.710c81f1.svg";
export { ForwardRef as ReactComponent };